import React, { useState } from "react";
import { Link } from 'react-router-dom';
import GroupLesson from "../../../asset/images/home/lesson-group.png"; // Update the path if needed
import GroupLesson2 from "../../../asset/images/home/lesson-group2.png"; // Update the path if needed
const LessonRead = () => {
    const [activeLesson, setActiveLesson] = useState(null);

    const toggleLesson = (id) => {
        setActiveLesson((prev) => (prev === id ? null : id));
    };

    return ( <div className="app-container">
        {/* Inline style */} <style>
        {`           .lesson-box {
            border: 1px solid #d9e6f5;
          }
          .lesson-header {
            cursor: pointer;
            transition: background 0.3s;
          }
          .lesson-header:hover {
            background-color: #f1f7ff;
          }
          .checkbox-custom {
            accent-color: #1A588B;
            margin-right: 12px;
          }
        `} </style>

        <div className="main-content-wrapper flex-1 flex flex-col overflow-hidden w-full">
            {/* Header */}
            <header className="bg-primary rounded-xl text-white px-6 m-3 lg:px-8 py-4 flex items-center justify-between">
                <div className="flex items-center gap-4">
                    {/* Progress Circle */}
                    <div className="relative w-16 h-16">
                        <svg className="w-16 h-16 transform -rotate-90">
                            <circle
                                cx="32"
                                cy="32"
                                r="28"
                                stroke="rgba(255,255,255,0.2)"
                                strokeWidth="6"
                                fill="none"
                            />
                            <circle
                                cx="32"
                                cy="32"
                                r="28"
                                stroke="white"
                                strokeWidth="6"
                                fill="none"
                                strokeDasharray="176"
                                strokeDashoffset="52"
                                strokeLinecap="round"
                                className="transition-all duration-500"
                            />
                        </svg>
                        <div className="absolute inset-0 flex flex-col items-center justify-center text-center text-sm font-semibold">
                            <span>70%</span>
                            <span className="text-[10px] font-normal">Complete</span>
                        </div>
                    </div>
                    <div>
                        <h1 className="text-base lg:text-xl font-semibold">Lesson Progress</h1>
                        <p className="text-xs opacity-80">
                            You’ve gone a long way! Keep up the good work.
                        </p>
                    </div>
                </div>

                <div className="flex items-center gap-3">
                    <button className="w-10 h-10 bg-white bg-opacity-20 rounded-full flex items-center justify-center hover:bg-opacity-30 transition-colors">
                        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth="2"
                                d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z"
                            />
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                        </svg>
                    </button>

                    <div className="hidden sm:flex items-center gap-2 bg-white text-primary px-3 py-2 rounded-xl shadow-sm">
                        <div className="w-8 h-8 bg-gradient-to-br from-gray-600 to-gray-800 text-white rounded-full flex items-center justify-center font-semibold text-sm">NG</div>
                        <div className="text-left">
                            <div className="text-[10px] text-gray-600 leading-tight">Profile</div>
                            <div className="text-xs font-semibold leading-tight">Nahom Girma</div>
                        </div>
                    </div>
                </div>
            </header>

            {/* Main Content */}
            <main className="main-content bg-white flex-1 p-4 lg:p-8">
                <div className="bg-[#E2F2FF] rounded-xl p-4 lg:p-3 shadow-md border border-blue-200">
                    <div className="grid grid-cols-1 lg:grid-cols-3 gap-3">
                        {/* Left Side */}
                        <div className="lg:col-span-2">
                            <div className="bg-white rounded-xl shadow-md p-3">
                                <h3 className="text-2xl font-bold mb-6 text-gray-700">Lesson 1: What is the Science of Reading?</h3>
                                <img
                                    src={GroupLesson}
                                    alt="Lesson Image"
                                    className="w-full h-auto mb-6 rounded-lg shadow-sm"
                                />
                                <h4 className="font-bold text-gray-800 mb-2 text-3xl">Introduction</h4>
                                <div className="border-l-2 border-gray-300 pl-4 text-gray-800 leading-relaxed">
                                    <p className="mb-3">
                                        The science of reading is a research-backed approach to teaching reading that focuses on explicit and systematic instruction of key literacy skills. It emphasizes the importance of foundational skills like phonemic awareness, phonics, fluency, vocabulary, and comprehension. The science of reading provides evidence for which techniques are most effective in helping all students become proficient readers.
                                    </p>
                                    <p className="font-medium mb-2">What are the components that make up the Science of Reading?</p>
                                    <ul className="list-disc pl-5 space-y-1">
                                        <li>Phonemic Awareness: identifying the most basic single letter sounds.</li>
                                        <li>Phonics: the blending of letter sounds to create and pronounce words.</li>
                                        <li>Fluency: the ability to read accurately, quickly, and with expression, allowing readers to focus on comprehension.</li>
                                        <li>Vocabulary: knowledge of the meanings of words, both in isolation and in context.</li>
                                        <li>Comprehension: the ability to understand and make meaning from written text.</li>
                                    </ul>
                                </div>

                                {/* Buttons */}
                                <div className="flex justify-end mt-6">
                                    <Link to={'/dashboard/modules'}>
                                        <button className="px-6 py-3 rounded-full bg-[#E2F2FF] hover:bg-[#c6e1f7] text-gray-700 font-medium mr-3 px-8">← Previous</button>
                                    </Link>
                                    <Link to={'/dashboard/modules/explanations'}>
                                        <button className="px-6 py-3 rounded-full bg-green hover:bg-greenDark text-white font-medium">Continue Lesson →</button>
                                    </Link>
                                </div>
                            </div>
                        </div>

                        {/* Right Side */}
                        <div className="lg:col-span-1">
                            <div className="bg-white rounded-xl shadow-md p-3">
                                <h4 className="text-xs text-gray-800">Module 1</h4>
                                <p className="text-xl font-bold text-primary mb-4">What is the Science of Reading?</p>
                                <img
                                    src={GroupLesson2}
                                    alt="Lesson Image"
                                    className="w-full h-auto mb-6 rounded-lg shadow-sm"
                                />

                                <div className="bg-[#004b87] border-primary border text-white rounded-xl pt-3 font-sans shadow-lg">
                                    <h3 className="text-sm font-semibold ml-3">Course Content</h3>
                                    <p className="font-semibold text-md text-white mb-4 ml-3">
                                        Module 1: What is the Science of Reading?
                                    </p>

                                    <div className="bg-white text-gray-800 rounded-lg overflow-hidden shadow-sm">
                                        {[1, 2, 3].map((lesson) => (
                                            <div className="lesson-box" key={lesson}>
                                                <div
                                                    className="lesson-header px-4 py-3 flex justify-between items-center bg-gray-200 border-primary border-b cursor-pointer"
                                                    onClick={() => toggleLesson(lesson)}
                                                >
                                                    <p className="font-medium text-lg text-primary mt-1">
                                                        {`Lesson ${lesson}: ${
                                                            lesson === 1
                                                                ? "What is the Science of Reading?"
                                                                : lesson === 2
                                                                    ? "Key Principles of the Science of Reading"
                                                                    : "Strategies for Effective Reading Instruction"
                                                        }`}
                                                    </p>
                                                    <svg
                                                        className={`w-4 h-4 text-gray-500 transform transition-transform duration-200 ${
                                                            activeLesson === lesson ? "rotate-180" : ""
                                                        }`}
                                                        fill="none"
                                                        viewBox="0 0 24 24"
                                                        stroke="currentColor"
                                                    >
                                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7" />
                                                    </svg>
                                                </div>

                                                <div className={`border-t border-gray-200 bg-gray-50 ${activeLesson === lesson ? "" : "hidden"}`}>
                                                    <ul className="text-sm">
                                                        {lesson === 1 && (
                                                            <>
                                                                <li className="flex items-center px-4 py-2 border-primary border-b">
                                                                    <input type="checkbox" checked className="w-4 h-4 accent-[#004b87]" />
                                                                    <span className="ml-2">Introduction</span>
                                                                </li>
                                                                <li className="flex items-center px-4 py-2 border-primary border-b">
                                                                    <input type="checkbox" className="w-4 h-4 accent-[#004b87]" />
                                                                    <span className="ml-2">Checkpoint Quiz</span>
                                                                </li>
                                                                <li className="flex items-center px-4 py-2 border-primary border-b">
                                                                    <input type="checkbox" className="w-4 h-4 accent-[#004b87]" />
                                                                    <span className="ml-2">Phonemic Awareness</span>
                                                                </li>
                                                                <li className="flex items-center px-4 py-2">
                                                                    <input type="checkbox" className="w-4 h-4 accent-[#004b87]" />
                                                                    <span className="ml-2">Phonics</span>
                                                                </li>
                                                            </>
                                                        )}
                                                        {lesson === 2 && (
                                                            <>
                                                                <li className="flex items-center px-4 py-2 border-primary border-b">
                                                                    <input type="checkbox" className="w-4 h-4 accent-[#004b87]" />
                                                                    <span className="ml-2">Introduction</span>
                                                                </li>
                                                                <li className="flex items-center px-4 py-2 border-primary border-b">
                                                                    <input type="checkbox" className="w-4 h-4 accent-[#004b87]" />
                                                                    <span className="ml-2">Core Skills</span>
                                                                </li>
                                                            </>
                                                        )}
                                                        {lesson === 3 && (
                                                            <>
                                                                <li className="flex items-center px-4 py-2 border-primary border-b">
                                                                    <input type="checkbox" className="w-4 h-4 accent-[#004b87]" />
                                                                    <span className="ml-2">Reading Practices</span>
                                                                </li>
                                                                <li className="flex items-center px-4 py-2 border-primary border-b">
                                                                    <input type="checkbox" className="w-4 h-4 accent-[#004b87]" />
                                                                    <span className="ml-2">Assessments</span>
                                                                </li>
                                                            </>
                                                        )}
                                                    </ul>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </main>

            {/* Footer */}
            <footer className="footer text-center text-gray-500 text-xs py-4">Read 21 © 2025 - All Rights Reserved</footer>
        </div>
    </div>


);
};

export default LessonRead;
